function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Semantics as ColorOverrides, Tokens } from '../../themes/caviar/color';
import { Semantics as BorderRadiusOverrides } from '../../themes/caviar/borderRadius';
import { Semantics as CaviarTextStyles } from '../../themes/caviar/textStyle';
import { IconsBrands } from '../icons';
import { Brands as LogoBrands } from '../logo';
import { Semantics as ShapeOverrides } from '../../themes/caviar/shape';

var caviarColorsExport = function caviarColorsExport() {
  var CaviarColorTokens = Tokens;
  var CaviarColors = {};
  Object.keys(Tokens).forEach(function (tokenName) {
    var keyName = tokenName.replace('SystemCaviar', '');
    CaviarColors[keyName] = CaviarColorTokens[tokenName];
  });
  return CaviarColors;
};

export var CaviarColors = caviarColorsExport();
export var CaviarOverrides = {
  BorderRadius: _objectSpread({}, BorderRadiusOverrides),
  Colors: _objectSpread({}, ColorOverrides),
  Icons: {
    Brand: IconsBrands.Caviar
  },
  Logo: {
    Brand: LogoBrands.Caviar
  },
  Shape: _objectSpread({}, ShapeOverrides),
  Typography: {
    FontFamily: 'Caviar-Market',
    TextStyles: _objectSpread({}, CaviarTextStyles)
  }
};